module.exports = __webpack_public_path__ + "static/media/linha-miolo.f406e9fe.svg";